module.exports = __webpack_public_path__ + "img/作品提交.87683038.png";